// extracted by mini-css-extract-plugin
export default {"setPasswordForm":"style_setPasswordForm__gwuqo"};